import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import type { FlattenedCustomGraphQL } from '@core/jss-graphql';
import { getFieldsFromCustomGraphQL } from '@core/jss-graphql';
import type { InnogyComponentRendering } from '@core/jss-models';

import type { EnrichedBlogPage } from '../blog.model';
import { enrichBlogPages, sortByCreatedAtDate } from '../utils';
import { BlogPostComponent } from '../blog-post/blog-post.component';

@Component({
  selector: 'wl-blog-index-container[rendering]',
  templateUrl: './blog-index-container.component.html',
  standalone: true,
  imports: [BlogPostComponent],
})
export class BlogIndexContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: InnogyComponentRendering | any;

  data?: FlattenedCustomGraphQL;
  blogPages: EnrichedBlogPage[] = [];

  ngOnInit() {
    if (this.rendering) {
      this.data = getFieldsFromCustomGraphQL(this.rendering);
      this.blogPages = enrichBlogPages(this.data?.context['children']);

      if (this.data?.fields['SortOnPublicationDate'].value) {
        this.blogPages.sort(sortByCreatedAtDate);
      }
    }
  }
}
